import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CommonFormComponent from '../CommonField/CommonFormComponent';
import CountryList from '../CountryList';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

import PlaceGeoSuggest from '../Common/GeoSuggest/PlaceGeoSuggest';
import { updateLocationStatus } from '../../actions/getLocation';
import { updateListingMap } from '../../actions/updateListingMap';
import { getLocationData } from '../../actions/getLocation';
import messages from '../../locale/jsonMessages';
import validate from './validate';
import update from './update';

import locationIcon from '/public/SiteIcons/locationIdea.svg';

import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';
class Page5 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    isLocationChosen: PropTypes.bool,
    previousPage: PropTypes.any,
    onSubmit: PropTypes.any,
    updateLocationStatus: PropTypes.any,
    nextPage: PropTypes.any,
    isExistingList: PropTypes.bool,
    updateListingMap: PropTypes.any,
    mapUpdateLoading: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      hideSuggestInput: true,
    };
  }

  UNSAFE_componentWillMount() {
    const { isExistingList, isLocationChosen, listId } = this.props;
    if (!isLocationChosen && !isExistingList && !listId) {
      this.setState({ hideSuggestInput: false });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isExistingList, isLocationChosen, listId } = nextProps;
    if (!isLocationChosen && !isExistingList && !listId) {
      this.setState({ hideSuggestInput: false });
    } else {
      this.setState({ hideSuggestInput: true });
    }
  }

  onSuggestSelect = (data, value) => {
    return data ? this?.props?.getLocationData(value) : '';
  }

  renderPlacesSuggest = ({ input, label, meta: { touched, error }, containerClassName }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <PlaceGeoSuggest
          {...input}
          placeholder={label}
          id={'becomeHost'}
          onSuggestSelect={this.onSuggestSelect}
          containerClassName={containerClassName}
        />
        {touched && error && <span>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderCountryList({ input }) {
    return <CountryList input={input} className='commonSelectField' />
  }

  renderLocationInput = () => {
    const { updateLocationStatus, previousPage, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <div className={cx(s.landingMainContent, s.locationOverflowHidden, 'becomeHostGeoSuggest')}>
          <label className='commonLabelText'>
            <FormattedMessage {...messages.yourLocation} /><sup className='isRequiredStar'>*</sup>
          </label>
          <FormGroup className={cx(s.noMargin, 'fullAddressSection')}>
            <Field
              name="location"
              component={this.renderPlacesSuggest}
              label={formatMessage(messages.searchYourLocation)}
              containerClassName='becomeHostGeoSuggest'
            />
          </FormGroup>
          <div className={cx(s.searchToolTip, cs.spaceTop2)}>
            <img src={locationIcon} className={'commonIconSpace'} />
            <span className={cx(s.locationTipCss, cs.commonMediumText)}><FormattedMessage {...messages.searchToolTip} /></span>
          </div>
        </div>
        <FooterButton
          nextPage={updateLocationStatus}
          previousPage={previousPage}
          previousPagePath={"car"}
          formPage={formPage}
          step={step}
        />
      </div>
    );
  }

  renderLocationForm = () => {
    const { previousPage, updateListingMap, valid, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    let isDisabled = true;
    if (valid) {
      isDisabled = false;
    }
    return (
      <div>
        <div className={s.landingMainContent}>
          <div className="oneColumnGrid">
            <FormGroup className={cs.noMargin}>
              <ControlLabel className='commonLabelText'>
                <FormattedMessage {...messages.country} /> <sup className='isRequiredStar'>*</sup>
              </ControlLabel>
              <Field name="country" component={this.renderCountryList} className='commonSelectField' />
            </FormGroup>

            <Field
              name="street"
              component={CommonFormComponent}
              inputClass='commonInputField'
              labelText={formatMessage(messages.street)}
              placeholder={formatMessage(messages.street)}
              maxLength={255}
              isRequiredInput
            />

            <Field
              name="buildingName"
              component={CommonFormComponent}
              inputClass='commonInputField'
              placeholder={formatMessage(messages.buildingName)}
              labelText={formatMessage(messages.buildingName)}
              maxLength={255}
            />

            <div className='twoColumnGrid'>
              <Field
                name="city"
                component={CommonFormComponent}
                inputClass='commonInputField'
                placeholder={formatMessage(messages.city)}
                labelText={formatMessage(messages.city)}
                maxLength={255}
                isRequiredInput
              />

              <Field
                name="state"
                component={CommonFormComponent}
                inputClass='commonInputField'
                placeholder={formatMessage(messages.state)}
                labelText={formatMessage(messages.state)}
                maxLength={255}
                isRequiredInput
              />

              <Field
                name="zipcode"
                component={CommonFormComponent}
                inputClass='commonInputField'
                placeholder={formatMessage(messages.zipcode)}
                labelText={formatMessage(messages.zipcode)}
                maxLength={255}
                isRequiredInput
              />
            </div>
          </div>
        </div>
        <FooterButton
          isDisabled={isDisabled}
          previousPage={previousPage}
          previousPagePath={"car"}
          type={"location"}
          updateListingMap={updateListingMap}
          formPage={formPage}
          step={step}
        />
      </div>
    );
  }

  render() {
    const { error, handleSubmit } = this.props;
    const { formatMessage } = this.props.intl;
    const { hideSuggestInput } = this.state;

    return (
      <div>
        <div className={cx(s.stepGrid, 'stepGridRTL')}>
          <SidePanel
            title={formatMessage(messages.step1HeadingNew)}
            landingContent={formatMessage(messages.whereLocated)}
          />
          <div>
            <form onSubmit={handleSubmit}>
              {error && <strong>{formatMessage(error)}</strong>}
              {
                hideSuggestInput && this.renderLocationForm()
              }
              {
                !hideSuggestInput && this.renderLocationInput()
              }
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Page5 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update
})(Page5);

const mapState = (state) => ({
  isLocationChosen: state.location.isLocationChosen,
  isExistingList: state.location.isExistingList,
  loading: state.loader.location,
  mapUpdateLoading: state.location.mapUpdateLoading
});

const mapDispatch = {
  updateLocationStatus,
  updateListingMap,
  getLocationData
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(Page5)));